import * as THREE from 'three';
import Axis from '@scene/axis/index';
import AbstractGenerator from '@scene/misc/generator';
//import { APP_TOOLTIPS } from '../../../texts/tooltips';
//import { Tooltip } from '@components/Tippy';


export const buttons = [{
  id: '1',
  icon: 'icon_rebar-slabwallconnection-01',
  tooltip:"TT119", //APP_TOOLTIPS.TOOLTIP_SLAB_TO_WALL_CONNECTION.Content,
  config: {
    orientation: AbstractGenerator.orientation.X,
    ground: {
      width: 1000,
      height: 1000,
      depth: 500
    },
    reinforcement: {
      width: {
        active: false,
        value: 1000
      },
      height: {
        active: true,
        value: 300
      },
      depth: {
        active: false,
        value: 200
      }
    },
    camera3D: {
      orientation: Axis.types.Y_TOP
    },
    camera2D: {
      position: new THREE.Vector3(0.001, 1345.362, 0),
      orientation: Axis.types.Y_TOP_2D
    },
    modelType: 1
  }
}, {
  id: '2',
  icon: 'icon_rebar-beamwallconnection-02',
  tooltip:"TT120", //APP_TOOLTIPS.TOOLTIP_BEAM_CONNECTION.Content,
  config: {
    orientation: AbstractGenerator.orientation.X,
    ground: {
      width: 1000,
      height: 1000,
      depth: 500
    },
    reinforcement: {
      width: {
        active: true,
        value: 800
      },
      height: {
        active: true,
        value: 300
      },
      depth: {
        active: false,
        value: 200
      }
    },
    camera3D: {
      orientation: Axis.types.Y_TOP
    },
    camera2D: {
      position: new THREE.Vector3(0.001, 1345.362, 0),
      orientation: Axis.types.Y_TOP_2D
    },
    modelType: 2
  }
}, {
  id: '3',
  icon: 'icon_rebar-slabextension-03',
  tooltip:"TT121", //APP_TOOLTIPS.TOOLTIP_SLAB_EXTENSION.Content,
  config: {
    orientation: AbstractGenerator.orientation.X,
    ground: {
      width: 1000,
      height: 300,
      depth: 500
    },
    reinforcement: {
      width: {
        active: false,
        value: 1000
      },
      height: {
        active: false,
        value: 300
      },
      depth: {
        active: false,
        value: 200
      }
    },
    camera3D: {
      orientation: Axis.types.Y_TOP
    },
    camera2D: {
      position: new THREE.Vector3(0.001, 1345.362, 0),
      orientation: Axis.types.Y_TOP_2D
    },
    modelType: 3
  }
}, {
  id: '4',
  icon: 'icon_rebar-wallslabconnection-04',
  tooltip:"TT119", //APP_TOOLTIPS.TOOLTIP_SLAB_TO_WALL_CONNECTION.Content,
  config: {
    orientation: AbstractGenerator.orientation.Y,
    ground: {
      width: 1000,
      height: 1000,
      depth: 500
    },
    reinforcement: {
      width: {
        active: false,
        value: 1000
      },
      height: {
        active: true,
        value: 300
      },
      depth: {
        active: false,
        value: 200
      }
    },
    camera3D: {
      orientation: Axis.types.Z_TOP
    },
    camera2D: {
      position: new THREE.Vector3(0, 1345, 0),
      orientation: Axis.types.X_TOP_Y_LEFT_2D
    },
    modelType: 4
  }
}, {
  id: '5',
  icon: 'icon_rebar-wallextension-05',
  tooltip:"TT123", //APP_TOOLTIPS.TOOLTIP_WALL_EXTENSION.Content,
  config: {
    orientation: AbstractGenerator.orientation.Y,
    ground: {
      width: 1000,
      height: 300,
      depth: 500
    },
    reinforcement: {
      width: {
        active: false,
        value: 1000
      },
      height: {
        active: false,
        value: 300
      },
      depth: {
        active: false,
        value: 200
      }
    },
    camera3D: {
      orientation: Axis.types.Z_TOP
    },
    camera2D: {
      position: new THREE.Vector3(0, 1345, 0),
      orientation: Axis.types.X_TOP_Y_LEFT_2D
    },
    modelType: 5
  }
}];

export const actionButtons = [{
  id: 'icon_rebaractiontype1',
  icon: 'icon_rebaractiontype1',
  config: {
    reinforcement: {
      actionType: {
        type: '/lm',
        active: true
      }
    }
  },
  tooltip: "TT209",
}, {
  id: 'icon_rebaractiontype2',
  icon: 'icon_rebaractiontype2',
  config: {
    reinforcement: {
      actionType: {
        type: 'on the section',
        active: true
      }
    }
  },
  tooltip: "TT210",
}, {
  id: 'icon_rebaractiontype3',
  icon: 'icon_rebaractiontype3',
  config: {
    reinforcement: {
      actionType: {
        type: 'per rebar',
        active: true
      }
    }
  },
  tooltip: "TT211",
}];



// WEBPACK FOOTER //
// ./src/reducers/selectors/application/initialState-rebar-reinforcement.js